import Api from './ApiService'

export default {
    get(keyword, pageNumber) {
        return Api().get(`edicoes?keyword=${keyword}&pageNumber=${pageNumber}`);
    },
    getAll() {
        return Api().post(`edicoes/all`);
    },
    getOne(id) {
        return Api().get(`edicoes/${id}`);
    },
    create(data) {
        return Api().post(`edicoes`, data);
    },
    update(data) {
        return Api().put(`edicoes/${data.id}`, data);
    },
    vincularSemEdicao(id) {
        return Api().put(`edicoes/${id}/vincular-sem-edicao`);
    }
}
